export default __webpack_public_path__ + "static/media/support-img.d58f5d70.png";